import React, { Component } from 'react';

import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { Storage } from 'aws-amplify';

export default class UploadList extends Component {
  constructor(props) {
    super(props)
    this.state = {
       progress: 0
    }
  }
  
  // when this component mounts, it will upload to the aws s3 bucket
  // and track the progress of the upload, and the file size being 
  // uploaded. refer to the other uploadList component.
  componentDidMount(){
    console.log("upload photo!")
    let {shot} = this.props
    
    // let sampleShots = this.props.sampleShots;
    shot.finish = false
    shot.uploading = true
    shot.failed = false
    this.props.updateSampleShot(this.props.index,shot)
    
    Storage.put(`photo/${this.props.id}/sample-images/${shot.file.name}`,
    shot.file,
    { 
        contentType: shot.file.type, 
        level: "public", 
        progressCallback:(progress)=>{
          // console.log("Progress: "+ (progress.loaded/progress.total)*100);
          let computedProgress = Math.floor((progress.loaded/progress.total)*100)
          if(computedProgress >= this.state.progress){
            console.log("Progress: "+ Math.floor(((progress.loaded/progress.total)*100)));
            this.setState({
              progress: computedProgress
            })
          }
        }
      })
      .then (result => {
        shot.finish = true
        shot.uploading = false
        shot.failed = false
        console.log(this.props.index + " finished")
        this.props.updateSampleShot(this.props.index,shot)
        console.log(result)
      })
      .catch(err =>{
        shot.finish = false
        shot.uploading = false
        shot.failed = true
        this.props.updateSampleShot(this.props.index,shot)
      });
  }
  
  render() {
    const {shot} = this.props
    return (
      <Paper elevation={1} style={{ padding: 20, margin: '10px 0' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
          <div
            style={{
              minWidth: 130,
              minHeight: 70,
              marginRight: 20,
              backgroundImage: `url(${shot.src})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover'
            }}
          >
          </div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <Typography variant="h6">
                  {shot.file.name}
                </Typography>
                <Typography variant="subtitle1" component="span">
                  {shot.computedSize.toFixed(2)+" "+ shot.computedSizeUnit}
                </Typography>
              </div>
              {/* <div >
                <button style={{ padding: 0, border: 0, background: 'transparent', cursor: 'pointer', outline: 0 }} onClick={()=>this.removeSampleImage(index)}>
                  <CloseIcon style={{ color: "rgba(0,0,0,0.6)" }}  />
                </button>
              </div> */}
            </div>
            <LinearProgress variant="determinate" style={{height: 3}} value={this.state.progress} />
          </div>
        </div>
      </Paper>
    )
  }
}
